import { render, staticRenderFns } from "./AccountSettingDefault.vue?vue&type=template&id=dbd20efc&scoped=true&"
import script from "./AccountSettingDefault.vue?vue&type=script&lang=js&"
export * from "./AccountSettingDefault.vue?vue&type=script&lang=js&"
import style0 from "../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=dbd20efc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd20efc",
  null
  
)

export default component.exports